import { render, staticRenderFns } from "./Similar.vue?vue&type=template&id=75e799c6&scoped=true&"
import script from "./Similar.vue?vue&type=script&lang=js&"
export * from "./Similar.vue?vue&type=script&lang=js&"
import style0 from "./Similar.vue?vue&type=style&index=0&id=75e799c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e799c6",
  null
  
)

export default component.exports